import { api } from "./api";

export const themeApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getThemePreference: builder.query<any, void>({
      query: () => ({
        url: "/Account/GetUserThemePreference",
        method: "GET",
      }),
      providesTags: ["ThemePreference"],
    }),
    saveThemePreference: builder.mutation<any, { theme: string }>({
      query: (body) => ({
        url: "/Account/SaveThemePreference",
        method: "POST",
        body: body,
      }),
      invalidatesTags: ["ThemePreference"],
    }),
  }),
});

export const { useGetThemePreferenceQuery, useSaveThemePreferenceMutation } =
  themeApi;